import React, { useMemo } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import { Select2 } from "select2-react-component";
// import {isSet,currencyListUtil,userUtilList} from '../../Utils/CommonFunctions';

const PickList = (props)=>{
    const {value,isDefault,required,options} = props;
    let attr = setAndGetAttributes(props);

    const  fieldOnChangeHandler = (value)=>{
      const {changeHandler} = props;
      changeHandler(value);
    } 
    const selectOptionsState = useMemo(() => {
      let selectOptions = [{label:'-None-',value:''}];
      try{
       
          selectOptions = options.map((item)=>{
            return(
              {
                label:item.value,
                value:item.id,
              }
            )
          })
      }catch(e){
  
      }
      return selectOptions;
    }, [options]);
     return( 
      <Wrp>
        {(isDefault===true)?
          <select 
          {...attr}
          value={value}
          onChange={e => fieldOnChangeHandler(e.target.value)}>
          {selectOptionsState.map((opt)=>{
            return( 
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            )
          })}  
          </select>
        :
        <div className={required===true ? "mandatory select2-arrow" : "select2-arrow" }>
           <Select2 
            data={selectOptionsState}
            {...attr}
            minCountForSearch ={1}
            value={value}
            update={value => fieldOnChangeHandler(value)}
            >
          </Select2>
        </div>
         
    }
       
        
      </Wrp>        
    );
}


PickList.defaultProps = {
  isMandatory:false,
  isDefault:false,
  isNoneAllowed:true,
  required:false,
  className: 'form-control'
}

export default PickList;